import { map } from 'rxjs/operators';
import { Injectable, OnDestroy } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Command, CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { InvoiceService } from '../data/invoice.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { Observable } from 'rxjs';

@Injectable()
export class InvoicePdfWithRegulationsCommandHandler implements ICommandHandler {
  constructor(
    private _service: InvoiceService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command.id !== invoiceCommand.getpdfWithRegulations) {
      return false;
    }
    if (command instanceof Command) {
      return command.context;
    }
    return false;
  }

  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof Command) {
      const tab = this._nativeWindow.openTab();
      return this._service.getPdfWithRegulations(command.context.id).pipe(
        map(res => this._nativeWindow.openFile(res, `${command.context.id}.pdf`, tab)),
        map(x => true)
      );
    }
  }
}
